var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPopupDiscordLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100px",
    height: "100px",
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\u7F16\u7EC4 28") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "100%",
    y1: "50%",
    x2: "-2.08166817e-14%",
    y2: "50%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#747DF7",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4851BC",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    cx: "50%",
    cy: "50%",
    fx: "50%",
    fy: "50%",
    r: "82.8310483%",
    gradientTransform: "translate(0.500000,0.500000),scale(0.757143,1.000000),rotate(37.130924),translate(-0.500000,-0.500000)",
    id: "radialGradient-2"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C2C4CD",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M75.3491213,27.4762272 C75.3296653,27.4387628 75.2974226,27.4094058 75.2581686,27.3934145 C70.7196733,25.3241187 65.9302596,23.8485488 61.009785,23.0036316 C60.9180965,22.9866923 60.8258117,23.0300903 60.7808556,23.1112881 C60.1286871,24.2875703 59.5366625,25.4958059 59.0070399,26.7313861 C53.703037,25.9312756 48.3078911,25.9312756 43.0038882,26.7313861 C42.4707593,25.4926684 41.8692474,24.2841316 41.2020961,23.1112881 C41.1552679,23.0320328 41.064406,22.9893262 40.9730477,23.0036316 C36.0520531,23.846775 31.2623284,25.3224558 26.724426,27.3935328 C26.6855798,27.4098984 26.6528022,27.4378415 26.6306162,27.4735062 C17.5557032,40.9409805 15.0697421,54.0773223 16.2892702,67.0509964 C16.2962018,67.1152394 16.3290655,67.1739388 16.380342,67.2136642 C21.6645797,71.1017833 27.5750635,74.0696145 33.8595703,75.9905089 C33.9502099,76.0175286 34.048195,75.9856217 34.1051664,75.9105355 C35.4549421,74.0854383 36.6509448,72.1528218 37.6810123,70.1323386 C37.7096412,70.0762572 37.7127572,70.0106833 37.6895734,69.9521706 C37.6663897,69.8936579 37.6191218,69.8477981 37.5597023,69.8261682 C35.6736935,69.10905 33.8478167,68.2445811 32.0992069,67.240874 C32.0347002,67.2031899 31.9933388,67.1360334 31.9889182,67.0618037 C31.9844975,66.987574 32.0175994,66.9160382 32.077183,66.8710562 C32.4451328,66.5979287 32.8066983,66.316409 33.1615916,66.0267216 C33.2250819,65.9747565 33.3127166,65.9630227 33.3877829,65.9964358 C44.8436566,71.1919862 57.2462003,71.1919862 68.5664783,65.9964358 C68.6417732,65.9608678 68.730952,65.9716 68.7955267,66.0240006 C69.1508234,66.3152196 69.5133165,66.5976579 69.8826734,66.8710562 C69.9425757,66.9155768 69.9762007,66.9868439 69.9723294,67.061079 C69.968458,67.135314 69.9276,67.2027452 69.8633877,67.240874 C68.1187541,68.2530243 66.2912222,69.1169518 64.4002732,69.8234472 C64.3408826,69.8459066 64.29394,69.892456 64.2712123,69.9514271 C64.2484846,70.0103982 64.2521265,70.0762002 64.2812251,70.1323386 C65.3285383,72.1415856 66.5227798,74.0717673 67.854333,75.9073413 C67.9097573,75.9845606 68.0086612,76.0179101 68.0999291,75.990154 C74.3956974,74.075772 80.3165115,71.1076649 85.6073717,67.2136642 C85.6594878,67.1758666 85.6926772,67.117577 85.6984435,67.0537173 C87.1584486,52.0547996 83.2541491,39.0261143 75.3491213,27.4762272 L75.3491213,27.4762272 Z M39.3918517,59.1513747 C35.9427919,59.1513747 33.1008771,56.0060301 33.1008771,52.1431726 C33.1008771,48.2803151 35.8876726,45.1347339 39.3918517,45.1347339 C42.9234117,45.1347339 45.7378264,48.3076433 45.6827072,52.142936 C45.6827072,56.0060301 42.8957926,59.1513747 39.3918517,59.1513747 Z M62.6514575,59.1513747 C59.2025167,59.1513747 56.360602,56.0060301 56.360602,52.1431726 C56.360602,48.2803151 59.1473975,45.1347339 62.6514575,45.1347339 C66.1832556,45.1347339 68.9975513,48.3076433 68.942432,52.142936 C68.942432,56.0060301 66.1832556,59.1513747 62.6514575,59.1513747 Z",
    id: "path-3"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-15.0%",
    y: "-19.8%",
    width: "127.1%",
    height: "135.8%",
    filterUnits: "objectBoundingBox",
    id: "filter-4"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: -1,
    dy: -1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.5 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "pop-up",
    transform: "translate(-310.000000, -230.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-28",
    transform: "translate(310.000000, 230.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50,0 C22.3900391,0 0,22.3900391 0,50 C0,77.6099609 22.3900391,100 50,100 C77.6099609,100 100,77.6099609 100,50 C100,22.3900391 77.6099609,0 50,0 Z",
    id: "\\u5F62\\u72B6",
    fill: "url(#linearGradient-1)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u5F62\\u72B6",
    opacity: 0.916015625
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-4)",
    xlinkHref: "#path-3"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "url(#radialGradient-2)",
    xlinkHref: "#path-3"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPopupDiscordLogo);
export default __webpack_public_path__ + "static/media/popup-discord-logo.e1f7c307cffc457c91e1a44afef40826.svg";
export { ForwardRef as ReactComponent };